var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fab",class:_vm.fabClasses,on:{"click":function($event){return _vm.$emit('click')}}},[_c(_vm.icon,{tag:"component",staticClass:"icon",attrs:{"iconColor":_vm.iconColor,"width":"48","height":"48"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }